import { Card, Table, Row, Typography, Button, Spin, message, Col } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../utils/HTTPClient";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment/moment";
import { TeamOutlined, CheckCircleOutlined, DownloadOutlined, OpenAIOutlined, InfoCircleFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { DomainModal } from "./DomainModal";
import { LeadModal } from "./LeadModal";
import styled from 'styled-components';

const AB_Website = () => {
    const navigate = useNavigate();
    const [website, setWebsite] = useState(null);
    const [loading, setLoading] = useState(false);
    const [lastMonthLeads, setLastMonthLeads] = useState(null);
    const [showDomainModal, setShowDomainModal] = useState(false);
    const [showLeadModal, setShowLeadModal] = useState(false);
    const [selectedLeadData, setSelectedLeadData] = useState(null);
    const [pageSize, setPageSize] = useState(5);
    const { t } = useTranslation();

    const fetch = async () => {
        setLoading(true);
        try {
            const res = await HTTPClient.get("/ab_website/");
            const website = res.data;
            setWebsite(website);
            const lastMonth = moment().subtract(30, "days");
            const leads = website.leads.filter((lead) => moment(lead.created_at).isAfter(lastMonth));
            setLastMonthLeads(leads.length);
        } catch (e) {
            if (e.response.status === 404) {
                window.location.replace(e.response.data);
                return;
            }
            if (e.response.status === 402) {
                navigate("/home");
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    const activateWebsite = async () => {
        setLoading(true);
        try {
            const res = await HTTPClient.post("/ab_website/start");
            window.location.replace(res.data);
            return;
        } catch (e) {

        }
        setLoading(false);
    };

    const getEditLink = () => {
        setLoading(true);
        HTTPClient.get(`/ab_website/edit_url`).then((res) => {
            window.open(res.data, "_blank", "noopener,noreferrer");
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        });
    }

    const handleTableChange = (pagination) => {
        if (pagination.pageSize !== pageSize) {
            setPageSize(pagination.pageSize);
        }
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    let dataColumns = [
        {
            title: t("ab_website.leads.fields.name"),
            dataIndex: "name",
            key: "name",
            render: (name) => <Typography.Text>{name || "Lead"}</Typography.Text>,
            showMobile: true,
        },
        {
            title: t("ab_website.leads.fields.email"),
            dataIndex: "email",
            key: "email",
            showMobile: false,
        },
        {
            title: t("ab_website.leads.fields.datetime"),
            dataIndex: "created_at",
            key: "created_at",
            render: (datetime) => moment(datetime).format("DD/MM/YYYY HH:mm"),
            showMobile: true,
        },
        {
            title: "Info",
            key: "info",
            render: (text, record) => (
                <Button
                    type="primary"
                    onClick={() => {
                        setSelectedLeadData([...record?.form_data, { label: "Datetime", value: moment(record.created_at).format("DD/MM/YYYY HH:mm") }]);
                        setShowLeadModal(true);
                    }}
                >
                    <InfoCircleFilled />
                </Button>
            ),
            showMobile: true,
        }
    ]

    if (!isLargeScreen) {
        dataColumns = dataColumns.filter((col) => col.showMobile);
    }

    const ButtonContainer = styled.div`
        display: flex;
        justify-content: center;
        margin-top: 20px;
    `;

    const StyledButton = styled(Button)`
        border-radius: 30px;
        margin: 0 10px;
        width: 200px;
        height: 50px;
    `;

    const websiteComponent = <>
        <div style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "250px", display: "flex", alignItems: "center", paddingTop: "25px", paddingBottom: "25px", paddingLeft: "27px", borderRadius: "27px" }}>
            <Row style={{ width: "100%", height: "200px" }}>
                {isLargeScreen && <Col span={6}>
                    <img src={"https://img.freepik.com/free-photo/abstract-digital-grid-black-background_53876-97647.jpg"} style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "14px" }} />
                </Col>}
                <Col span={isLargeScreen ? 18 : 24} style={{ padding: "20px 20px" }}>
                    <Row style={{ height: "60%", borderBottom: "1px solid #D9D9D9" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{t("ab_website.card.title")} {website?.project_info?.name}</Typography.Text>
                            <Button type="primary" onClick={() => getEditLink()}>
                                {t("ab_website.card.edit")}
                            </Button>
                        </div>
                        <Col span={24}>
                            <a href={website?.website_url} target="_blank" ><Typography.Text style={{ fontSize: "16px", color: "#5F4DEE" }}>{website?.website_url}</Typography.Text></a>
                        </Col>
                    </Row>
                    <Row style={{ padding: "20px 0px" }}>
                        <Col>
                            <a><Typography.Text onClick={() => setShowDomainModal(true)} style={{ fontSize: "16px", color: "#5F4DEE" }}>- {t("ab_website.card.domain")}</Typography.Text></a>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
        <Row style={{ marginTop: "35px", width: "100%", height: "500px" }}>
            <Col span={isLargeScreen ? 16 : 24}>
                <div style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "100%", padding: "22px 27px", borderRadius: "14px" }}>
                    <Row style={{ display: "flex", justifyContent: "space-between" }}>
                        <Col>
                            <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_website.leads.title")}</Typography.Text><br />
                            <Typography.Text style={{ fontSize: "12px" }}>{t("ab_website.leads.subtitle")}</Typography.Text>
                        </Col>
                    </Row>
                    <Row>
                        <Table
                            columns={dataColumns}
                            dataSource={website?.leads}
                            pagination={{ pageSize: pageSize }}
                            onChange={handleTableChange}
                            style={{ marginTop: "25px", width: "100%" }}
                        />
                    </Row>
                </div></Col>
            {isLargeScreen && <Col span={1}></Col>}
            <Col span={isLargeScreen ? 7 : 24} style={{ marginTop: isLargeScreen ? "0px" : "40px", display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
                <Row style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "rgba(95, 77, 238, 0.4)", width: "100%", height: isLargeScreen ? "24%" : "100%", padding: "18px 22px", borderRadius: "14px" }}>
                    <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
                        <Row><Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("ab_website.leads.counter.title")}</Typography.Text></Row>
                        <Row><Typography.Text style={{ fontSize: "27px", fontWeight: "bold" }}><TeamOutlined />{website?.leads.length}</Typography.Text></Row>
                    </Col>
                    <Col span={12} style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "10px" }}>
                        <div style={{ width: "50px", height: "25px", backgroundColor: "white", borderRadius: "21px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "bold", color: "#5F4DEE", marginBottom: "10px" }}>+{lastMonthLeads}</div> {t("ab_website.leads.counter.text")}
                    </Col>
                </Row>
            </Col>
        </Row>
    </>

    const noWebsiteComponent = <>
        <div style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", backgroundColor: "white", width: "100%", height: "250px", display: "flex", alignItems: "center", paddingTop: "25px", paddingBottom: "25px", paddingLeft: "27px", borderRadius: "27px" }}>
            <Row style={{ width: "100%", height: "200px" }}>
                <Col span={6}>
                    <img src={"https://img.freepik.com/free-photo/abstract-digital-grid-black-background_53876-97647.jpg"} style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "14px" }} />
                </Col>
                <Col span={18} style={{ padding: "20px 20px" }}>
                    <Row style={{ height: "60%", borderBottom: "1px solid #D9D9D9" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                            <Typography.Text style={{ fontSize: "24px", fontWeight: "bold" }}>{t("ab_website.card.title")} {website?.project_info?.name}</Typography.Text>
                        </div>
                        <div>
                            {t("ab_website.no_website.text")}
                        </div>
                    </Row>
                    <Row>
                        <Col>
                            <ButtonContainer>
                                <StyledButton
                                    type="primary"
                                    onClick={() => activateWebsite()}
                                    icon={< CheckCircleOutlined />}
                                >
                                    {t("ab_website.no_website.call_to_action1")}
                                </StyledButton>
                            </ButtonContainer>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    </>

    return (<>
        <Row style={{ backgroundColor: "white", width: "100%", height: "134px", padding: "27px 34px" }}>
            <Row>
                <Typography.Text style={{ fontSize: "27px", fontWeight: "bold" }}>
                    {t("ab_website.title")}
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text style={{ fontSize: "20px" }}>{t("ab_website.subtitle")}</Typography.Text>
            </Row>
        </Row>
    </>
    );
};

export { AB_Website };
